import IndexPage from './../pages/IndexPage'

export default [
    {
        name: 'dashboard.index',
        path: '/dashboard',
        component: IndexPage,
        meta: {
            title: 'Dashboard',
            layout: 'dashboard',
        }
    },
]